(function () {
  'use strict';

  let flag = 0;
  let callback = null;

  function updateFlag() {
    if (flag < 2) {
      flag += 1;
    }

    if (flag === 2) {
      runAll();

      if (callback) {
        callback();
      }
    }
  }

  document.addEventListener('swell:setup', updateFlag);

  // Convx 849: was `if (jQuery)`, which throws ReferenceError rather than being falsy when the
  // CDN fails, killing the Customer Fields opt-in logic further down this file.
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('swell:setup', updateFlag);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", runFirst, { once: true });
  } else {
    runFirst();
  }

  function runFirst() {
    CF.ready(() => {
      var $form = document.querySelector('form[data-cf-form="QrtpaD"]');

      if ($form) {
        $form.addEventListener('cf:form_submitted', function (event) {
          const loginNowMessage = document.querySelector('.login-now-message');
          if (loginNowMessage) {
            loginNowMessage.setAttribute('hidden', '');
          }

          localStorage.setItem('justRegistered', '1');
          event.detail.submissionData.is_loyalty_member = true;
          window.cdpTrackingCode.trackUserSignUp(event.detail.submissionData);
        });  

        const urlParams = new URLSearchParams(location.search);
        const storeCode = urlParams.get('store_code');

        if (storeCode) {
          $form.cfForm.setFieldValue('store_code', storeCode);
        }

        const storeCodeInput = $form.querySelector('input[name="store_code"]');

        if (storeCodeInput) {
          const fieldContainer = storeCodeInput.closest('.cf-field-container');

          if (fieldContainer) {
            fieldContainer.classList.add('visually-hidden');
          }
        }
      }
    });
    
    const justRegistered = localStorage.getItem('justRegistered');

    if (justRegistered) {
      document.documentElement.setAttribute('data-opting-in-for-membership', '');
      document.dispatchEvent(new CustomEvent('automatic-opt-in:loading'));
    }

    updateFlag();
  }

  function runAll() {
    const justRegistered = localStorage.getItem('justRegistered');

    if (!justRegistered) {
      return;
    }
    
    const customerDetails = swellAPI.getCustomerDetails();

    if (customerDetails && typeof customerDetails.isOptIn !== "undefined") {
      if (!customerDetails.isOptIn) {
        swellAPI.updateOptInCustomer(
          {
            shouldOptIn: true,
            rewardOnOptIn: true,
          },
          joinMembershipSuccess,
          joinMembershipError,
        );
      }

      localStorage.removeItem('justRegistered');
    }
  }

  function joinMembershipSuccess() {
    document.documentElement.removeAttribute('data-opting-in-for-membership');
    document.dispatchEvent(new CustomEvent('automatic-opt-in:success'));
  }

  function joinMembershipError() {
    document.documentElement.removeAttribute('data-opting-in-for-membership');
    document.dispatchEvent(new CustomEvent('automatic-opt-in:failed'));
  }

})();
